import schema, { generateType, } from './Schema';
export const Post = generateType(schema.getModel('discussionPost'));
export const Topic = generateType(schema.getModel('discussionTopic'));
//# sourceMappingURL=DiscussionModel.js.map